import React, {useEffect} from 'react'
import classes from "./style.module.scss"
import useStyles from 'isomorphic-style-loader/useStyles'
import { BlackMask } from "../../../../components/mask/index"
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { BigButton } from '../../../../components/button'
import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import MeChildHeader from '../../components/me-child-header'
import { action_fetch_address_list, action_set_default_address } from '../../../../../store/actions/pages/customer'
import AddressList from './components/address-list'
import { useStore } from 'react-redux'
import { useParams } from 'react-router-dom'
import { useQuery } from '../../../../hooks/common'
import MeLoading from '../../components/loading'
import NormalConfigConfirm from '../../../../../client/components/alert/config-confirm'
import { deleteAddress, updateAddress, addAddress } from '../../../../../api'
import MeListEmpty from '../../components/list-empty'
import { FormattedMessage, useIntl } from 'react-intl'
import AddressEditor from '../../../shoppingcart/fragments/address/address-editor'
import Alert from '../../../../components/alert'


const AddressBook = props => {
    useStyles(classes);
    const [loading, setLoading] = useState(true)
    const pageCustomer = useSelector(state => state.pageCustomer);
    const {addressList} = pageCustomer || {}
    const dispatch = useDispatch()

    const Intl = useIntl()

    const store = useStore()
    const params = useParams()
    const query = useQuery()
    const global = useSelector(state =>state.global);
    const [addressEditor, setAddressEditor] = useState({})

    useEffect(async () => {
        if (window.__INITIAL_STATE__) {
			// Allow the passed state to be garbage-collected
			delete window.__INITIAL_STATE__
		} else {
			await AddressBook.fetchData(store, params, query)
		}
    }, [])

    useEffect(() => {
        if(addressList){
            setLoading(false)
        } else {
            setTimeout(() => {
                setLoading(false)
            }, 5000)
        }
    },[addressList])

    const addAddressHandle = (address) => {
        // console.log('address', address)
        setAddressEditor({ address, show: true, country: global?.country });
    }


    const addressDelete = async (address) => {
        NormalConfigConfirm({
            boxStyle:{
                padding:"25px",
            },
            message:{
                text:  Intl.formatMessage({id: 'sure_delete_address', defaultMessage: "Are you sure to delete this address"}) + '?',
                style:{
                    fontFamily: 'Roboto',
                    fontSize: '14px',
                    lineHeight: 'normal',
                    color:'#222222',
                    textAlign: 'center'
                },
                html:false
            },
            btn1:{
                text: "Yes",
                style: {},
                clickHandle: async () =>{
                    setLoading(true);
                    let response = await deleteAddress(address?.id)
                    if(response?.code === 200){
                        dispatch(action_fetch_address_list());
                    }
                    setLoading(false);
                }
            },
            btn2:{
                text: "No",
                style: {},
                clickHandle:() =>{}
            }
        });
    }

    const addressDefault = (id) => {
        setLoading(true)
        dispatch(action_set_default_address(id))
        .then(res => {
            setLoading(false)
        })
    }

    const onBack = () => {
        window.history.back()
    }

    const onSubmitAddress = async (values) =>{
        // console.log('values', values)
        let response;

        if(values?.id){
            // update
            setLoading(true);
            response = await updateAddress(values);
            // console.log('response', response)
            if(response?.code === 200){
                setAddressEditor({ address: null, show: false });
                await dispatch(action_fetch_address_list());
            }else{
                // response?.result && Alert(response.result);
            }
            setLoading(false);
        }else{
            // add
            response = await addAddress(values);
            if(response?.code === 200){
                setAddressEditor({ address: null, show: false });
                await dispatch(action_fetch_address_list());
            }else{
                // response?.result && Alert(response.result);
            }
            setLoading(false);
        }

        return response;
    }

    return <div>
        <MeChildHeader name={Intl.formatMessage({id: 'address_book', defaultMessage: 'Address Book'})} onBack={() => onBack()}/>

        {
            addressList?.length > 0 ?
            <AddressList
                addressList={addressList}
                addressEdit={(address) => addAddressHandle(address)}
                addressDelete={(address) => addressDelete(address)}
                addressDefault={(id) => addressDefault(id)}
                />:
            <MeListEmpty/>
        }

        <div className={classes.AddAddressButton}>
            <BigButton onClick={() => addAddressHandle()}>
                <FormattedMessage id="add_new_address" defaultMessage={"Add New Address"}/>
            </BigButton>
        </div>

        <MeLoading loading={loading} />

        <AddressEditor country={global?.country} address={addressEditor?.address} onSubmit={onSubmitAddress} onClose={e => setAddressEditor({ ...addressEditor, show: false })} show={addressEditor?.show} />
    </div>
}


AddressBook.fetchData = async (store, params, search, headers) => {
    await store.dispatch(action_fetch_address_list(headers))
}

export default AddressBook
